const translations_de = {
    translation: {
        headlines:{
            resistanceInformation: 'Beständigkeitsinformationen',
            resultHeadline: 'Für {{media}} sind folgende Informationen verfügbar'
        },
        labels: {
            searchResults: 'Suchergebnisse für:',
            materialCategory: 'Kategorie Material',
            filterEignung: 'Nur Spalten mit folgenden Werten zeigen',
            selectStandardViewSubText: 'Finden Sie schnell passende Beständigkeit anhand von Medien/Werkstoffen',
            selectExpertViewSubText: 'Alle Medien Werkstoffkombinationen in einer tabellarischen Übersicht',
            selectedFilter: 'Aktive Filter:',
            temperaturSelected:'max. Medientemperatur:',
            temperaturSelection:'Bitte maximale Medientemperatur für {{medium}} wählen:',
            konzentrationSelected:'max. Konzentration:',
            konzentrationSelection:'Bitte maximale Konzentration für {{medium}} wählen:',
            zustandSelected:'Zustand des Mediums:',
            zustandSelection:'Bitte Zustand des Mediums wählen:',
            mediumSelected:'Medium:',
            mediumSelection:'Bitte eindeutiges Medium wählen:',
            material: 'Material',
            medium: 'Medium',
            completeMediumSelection: 'Bitte wählen Sie oben weitere Angaben zum Medium',
            mediumMissing: 'Bitte wählen Sie ein Betriebsmedium',
            contact:{
                button: 'Kontaktieren Sie uns',
                title: 'Sprechen Sie uns an.',
                text : 'Haben Sie Fragen zu unseren Beständigkeitsinformationen?\n Wir helfen Ihnen gerne.'
            },
            lastModified: 'Datenstand' 
        },
        buttons:{
            search: 'Suchen',
            accept: 'Akzeptieren',
            exportExcel: 'Tabelle als Excel-Datei speichern',
            language:'Sprache',
            refreshData: 'Daten neu laden'
        },
        infoText:{
            hiddenColumns: 'Für folgende Materialien sind keine Informationen verfügbar:',
            hintLimitations: 'Für weitere Informationen über Materialien in dieser Kategorie kontaktieren Sie uns bitte.'
        },
        placeholder:{
            search: "Medium / Material / Formel / CAS-Nr.",
            materialCategory: 'Kategorie wählen',
            filterEignung: 'Werte wählen'
        },
        info:{
            loading:{
                init: 'Daten werden geladen',
                progress: "Anwendung wird geladen... Bereits {{length}} Datensätze von ca. 16.000 geladen"

            }
        },
        table:{
            itemsPerPage: 'Einträge pro Seite: ',
            head:{
                Medium: 'Medium',
                Alternative_Namen: 'Alternative Namen',
                Formel: 'Formel',
                CAS_Nr: 'CAS-Nr.',
                Konzentration:'Konzentration',
                Temperatur: 'Temperatur',
                Zustand: 'Zustand',
                Anmerkung: 'Anmerkung'
            },
            gridLabels:{
                noRowsToShow: 'Keine Informationen verfügbar',
                page: 'Seite',
                more: 'mehr',
                to: 'bis',
                of: 'von',
                next: 'nächste',
                last: 'Letzte',
                first: 'Erste',
                previous: 'vorherige',
                loadingOoo: 'lade...',
                contains: 'enthält',
                notContains: 'enthält',
                equals: 'ist gleich',
                notEquals: 'ist nicht',
                startsWith: 'beginnt mit',
                endsWith: 'endet mit',
                filterOoo:'filtern...',
                andCondition: 'und',
                orCondition: 'oder'

            },
            select: {
                noResults: '(Keine Ergbnisse vorhanden)'
            }
        },
        key:{
            title:'Legende',
            suitable: 'geeignet',
            suitableAnm: 'geeignet (mit Einschränkungen)',
            lsuitability: 'bedingt geeignet',
            lsuitabilityAnm: 'bedingt geeignet (mit Einschränkungen)',
            nsuitability: 'nicht geeignet',
            noInfo: 'keine Angabe',
            Eignung: 'Eignung',
            TR: 'technisch rein, annähernd 100%',
            completeKey: 'vollständige Legende',
            DeRatingFactorTitle: 'Abminderungsfaktoren',
            DeRatingFactorText:'Armaturen und Rohrleitungen werden entsprechend DIN EN ISO 16138 für eine Lebensdauer von 25 Jahren ausgelegt. Durch den Einfluss von Chemikalien ist manchmal ein Abminderungsfaktor für den Druck bzw. die Temperatur hinterlegt. In Verbindung mit dem Druck-Temperatur-Diagramm kann der maximal zulässige Druck bzw. Temperatur für die entsprechende Chemikalie berechnet werden.'
        },
        resistanceKeys:{
            '+': 'Beständige Werkstoffe',
            '(+)': 'Beständige Werkstoffe - mit Einschränkungen', 
            'o': 'Bedingt beständige Werkstoffe',
            '(o)': 'Bedingt beständige Werkstoffe - mit Einschränkungen',
            '-': 'Nicht beständige Werkstoffe',
            '(-)': 'Nicht beständige Werkstoffe - mit Einschränkungen', 
            'kA': 'Keine Angaben verfügbar',
            'title':'Erläuterungen zur Beständigkeit'
        },
        resistanceDescriptions:{
            '+':'(geringe oder keine Beeinträchtigung)',
            'o': '(schwacher bis mäßiger Angriff)',
            '-':'(starker Angriff bis vollständige Zerstörung)'
        },
        resistanceTranslations:{
            title:{
                '+': 'Beständig',
                '(+)': 'Beständig - mit Einschränkungen', 
                'o': 'Bedingt beständig',
                '(o)': 'Bedingt beständig - mit Einschränkungen',
                '-': 'Nicht beständig ',
                'kA': 'Keine Angaben verfügbar'
            },
            description:{
               'default': 'Der Werkstoff {{materials}} ist für $t(resistanceTranslations.description.defaultMedia,{"count":{{mediumCount}}, "media":"{{mediadata}}"}) {{resistanceValue}}.',
               'default_plural': 'Die Werkstoffe {{materials}} sind für $t(resistanceTranslations.description.defaultMedia,{"count":{{mediumCount}}, "media":"{{mediadata}}"}) {{resistanceValue}}.',
               'defaultMedia': 'das Medium {{media}}',
               'defaultMedia_plural': 'die Medien {{media}}',
               'ka':'Für die Kombination des Werkstoffes {{materials}} und $t(resistanceTranslations.description.kaMedium, {"count": {{mediumCount}}, "media1":"{{mediadata}}" }) sind keine Angaben verfügbar',
               'ka_plural':'Für die Kombination der Werkstoffe {{materials}} und $t(resistanceTranslations.description.kaMedium, {"count": {{mediumCount}}, "media1":"{{mediadata}}" }) sind keine Angaben verfügbar',
               'kaMedium':'des Mediums {{media1}}',
               'kaMedium_plural':'der Medien {{media1}}'
            },
            resistanceResults:{
                '+': 'beständig',
                '(+)': 'beständig. Bitte beachten Sie die Einschränkungen bei den Werkstoffen', 
                'o': 'bedingt beständig',
                '(o)': 'bedingt beständig Bitte beachten Sie die Einschränkungen bei den Werkstoffen',
                '-': 'nicht beständig',
                'kA': 'keine Angaben verfügbar'
            },
            maxKonzentration: 'maximale Konzentration ',
            maxTemperatur: 'maximale Medientemperatur '
        },
        disclaimer: {
            text: '<p>Die nachfolgenden Informationen dienen in erster Linie als Orientierung und sollen die Auswahl geeigneter Materialien beim Einsatz von GEMÜ-Produkten erleichtern. Sie können nicht ohne weiteres auf alle Betriebsbedingungen und Anwendungsfälle angewendet werden. Die spezifische Auswahl der Werkstoffe sowie die Anwendung, Verwendung und Verarbeitung der bezogenen Produkte liegen ausschließlich im Verantwortungsbereich des Kunden bzw. des Endverwenders.</p><p>Generell ist die Beständigkeit von verschiedenen Faktoren wie beispielsweise Temperatur, Konzentration und Verschmutzungsgrad des Mediums, Art der mechanischen Beanspruchung sowie Oberflächenbeschaffenheit des Materials abhängig. Die verschiedenen Faktoren beeinflussen in der Praxis die Beständigkeit der Werkstoffe.</p><p>Die Inhalte der vorliegenden Beständigkeitsinformationen werden von uns nach bestem Wissen und Gewissen erstellt. Dennoch können wir keine Haftung für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Informationen übernehmen. Die Informationen entsprechen unserem Kenntnisstand zum Zeitpunkt der Veröffentlichung. Irrtümer und Fehler sind jedoch vorbehalten. Die Angaben in der Tabelle können von uns jederzeit und ohne Ankündigung geändert, aktualisiert oder modifiziert werden.<p></p>Aus der Verwendung der Beständigkeitsinformationen können keinerlei Ansprüche, gleich aus welchem Rechtsgrund, geltend gemacht werden. Dies gilt insbesondere für Gewährleistungsansprüche, Ansprüche aus fehlerhafter Beratung oder Ansprüche auf Schadensersatz.</p>',
            textCSV: 'Die nachfolgenden Informationen dienen in erster Linie als Orientierung und sollen die Auswahl geeigneter Materialien beim Einsatz von GEMÜ-Produkten erleichtern. Sie können nicht ohne weiteres auf alle Betriebsbedingungen und Anwendungsfälle angewendet werden. Die spezifische Auswahl der Werkstoffe sowie die Anwendung, Verwendung und Verarbeitung der bezogenen Produkte liegen ausschließlich im Verantwortungsbereich des Kunden bzw. des Endverwenders. Generell ist die Beständigkeit von verschiedenen Faktoren wie beispielsweise Temperatur, Konzentration und Verschmutzungsgrad des Mediums, Art der mechanischen Beanspruchung sowie Oberflächenbeschaffenheit des Materials abhängig. Die verschiedenen Faktoren beeinflussen in der Praxis die Beständigkeit der Werkstoffe. Die Inhalte der vorliegenden Beständigkeitsinformationen werden von uns nach bestem Wissen und Gewissen erstellt. Dennoch können wir keine Haftung für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Informationen übernehmen. Die Informationen entsprechen unserem Kenntnisstand zum Zeitpunkt der Veröffentlichung. Irrtümer und Fehler sind jedoch vorbehalten. Die Angaben in der Tabelle können von uns jederzeit und ohne Ankündigung geändert, aktualisiert oder modifiziert werden. Aus der Verwendung der Beständigkeitsinformationen können keinerlei Ansprüche, gleich aus welchem Rechtsgrund, geltend gemacht werden. Dies gilt insbesondere für Gewährleistungsansprüche, Ansprüche aus fehlerhafter Beratung oder Ansprüche auf Schadensersatz.',
            headline: 'Disclaimer',
            internalInformation:'Interne Information'
        },
        CSVOption:{
            Comma: 'CSV-Trenner: "," - Für Englische User',
            Semikolon: 'CSV-Trenner: ";" - Für Deutsche User'
        },
        Excel:{
            goToTable: 'Akzeptieren und weiter zur Tabelle',
            CreationTime: 'Datei erstellt'
        },
        singleWords: {
            and : 'und'
        },
        searchTipps:{
            title: 'Tipps für Ihre Suche',
            tip1: 'Sie können nach Medium, Material, chemischer Formel oder CAS-Nr. suchen',
            tip2: 'Kombinieren Sie Medium und Material um das Ergebnis einzuschränken'
        },
        disclaimerFooter:{
            hastelloy: 'Hastelloy ist eine (eingetragene) Markenbezeichnung der Firma Haynes International, Inc., USA.' 
        }
    }
}

export default translations_de;
